import { createRouter, createWebHistory } from 'vue-router'
import HomeApp from '../views/HomeApp.vue'

import AuthenticationRoutes from '@/router/authentication/authentication.js';

import DevelopmentRoutes from '@/router/development/index.js';

import OpenQueryRoutes from '@/router/open_queries/index.js';

import AERoutes from '@/router/agro_exporter/index.js';
import CustomerRoutes from '@/router/customer/index.js';
import PHRoutes from '@/router/packing_house/index.js';
import SPRoutes from '@/router/service_provider/index.js';
import OrgRoutes from '@/router/organization/index.js';
import UPRoutes from '@/router/user_profile/index.js';

const routes = [
  {
    path: "/",
    name: "home_path",
    component: HomeApp
  },
  ...AuthenticationRoutes,
  ...DevelopmentRoutes,
  ...OpenQueryRoutes,
  ...AERoutes,
  ...CustomerRoutes,
  ...PHRoutes,
  ...SPRoutes,
  ...OrgRoutes,
  ...UPRoutes
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
